import { Action } from '@ngrx/store';
import { AuthRequest, AuthResponse } from '@shared/models/auth.model';
import { ErrorResponse } from '@shared/models/error.model';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  REFRESH = '[Auth] Refresh',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILURE = '[Auth] Login Failure',
  LOGIN_RESET = '[Auth] Login Reset',
  LOGOUT = '[Auth] Logout',
  LOGIN_FAILURE_TEST = '[Auth] Login Failure Test',
  SELECT_STORE_SUCCESS = '[Auth] Select store success',
  CLEAR_AUTH_REQUEST = '[Auth] Clear Auth Request',
  LOGIN_STORE_TERMINATE_ERROR = '[Auth] Login Terminate Error'
}

export class LogInAction implements Action {
  readonly type = AuthActionTypes.LOGIN;

  constructor(public payload: AuthRequest) {}
}

export class RefreshAction implements Action {
  readonly type = AuthActionTypes.REFRESH;

  constructor(public payload: string) {}
}

export class LogInSuccessAction implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;

  constructor(public payload: AuthResponse) {}
}

export class LogInFailureAction implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE;

  constructor(public payload: ErrorResponse) {}
}

export class LoginReset implements Action {
  readonly type = AuthActionTypes.LOGIN_RESET;
}

export class LogOutAction implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export class LogInFailureTestAction implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE_TEST;

  constructor(public payload: ErrorResponse) {}
}

export class SelectStoreAction implements Action {
  readonly type = AuthActionTypes.SELECT_STORE_SUCCESS;

  constructor() {}
}

export class ClearAuthRequest implements Action {
  readonly type = AuthActionTypes.CLEAR_AUTH_REQUEST;

  constructor() {}
}

export class LogInStoreTerminateError implements Action {
  readonly type = AuthActionTypes.LOGIN_STORE_TERMINATE_ERROR;

  constructor(public payload: any) {}
}

export type All =
  | LogInAction
  | RefreshAction
  | LogInSuccessAction
  | LogInFailureAction
  | LoginReset
  | LogOutAction
  | LogInFailureTestAction
  | SelectStoreAction
  | ClearAuthRequest
  | LogInStoreTerminateError;
